import clsx from 'clsx'
import { useFormik } from 'formik'
import { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import '../masters/basic.css'
import httpService from '../../setup/http/httpServices'
import { Input, message } from 'antd'
import Select from 'react-select'
import loc from '../data/Location.json'
import { AddWebsiteLeftBreadcrum } from './AddWebsiteLeftBreadcrumb'
import { toAbsoluteUrl } from '../../_metronic/helpers'



export function AddWebsiteTags() {
  const history: any = useHistory()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [tags, setTags] = useState([])
  const [selectedTags, setSelectedTags] = useState([])
  const [searchedTags, setSearchedTags] = useState([])
  const [phraseErr, setPhraseErr] = useState(false)

  const [phraseInput, setPhraseInput] = useState<string>('')
  const [phrase, setPhrase] = useState<string[]>([])
  const [errorMessage, setErrorMessage] = useState('');
  const [suggestedPhrases, setSuggestedPhrases] = useState([])
  const [selectAllMode, setSelectAllMode] = useState<boolean>(true);
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');




  const formatDate = (inputDate: string): string => {
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const formattedDate: string = new Date(inputDate).toLocaleDateString('en-GB', options);
    return formattedDate.split('/').join('-');
  };

  console.log('date', formatDate(date))
  console.log('time', time)

  useEffect(() => {
    const currentDate = new Date();

    const formattedDate = currentDate.toISOString().substr(0, 10);

    const formattedTime = ("0" + currentDate.getHours()).slice(-2) + ":" + ("0" + currentDate.getMinutes()).slice(-2);

    setDate(formattedDate);
    setTime(formattedTime);
  }, []);


  const handleDateChange = (event) => {
    setDate(event.target.value);
  };

  const handleTimeChange = (event) => {
    setTime(event.target.value);
  };



  // console.log('suggestedPhrases', suggestedPhrases)

  // const suggestedPhrases = ['Hello', 'World', 'React', 'TypeScript'];

  useEffect(() => {
    console.log(history.location.state)
  }, [])

  // const formik = useFormik({
  //   initialValues: initialValues,
  //   validationSchema: registrationSchema,
  //   enableReinitialize: true,
  //   onSubmit: (values, {setStatus, setSubmitting}) => {
  //     console.log("idhar");

  //     setLoading(true)
  //     setTimeout(() => {
  //       try {
  //         // let request: any = values;
  //         // request.agencyAssociated = agencyAssociated;
  //         setLoading(false)
  //         setSubmitting(false)
  //         history.push({
  //           pathname: '/agencyDetails',
  //           state: {
  //             ...history.location.state,
  //             ...{companyDetails: values},
  //           },
  //         })
  //       } catch {
  //         setLoading(false)
  //         setSubmitting(false)
  //         setStatus('Registration process has broken')
  //         // Remove logs when not needed
  //       }
  //     }, 1000)
  //   },
  // })

  // const checkHandle = (cat) => {
  //   let x = selectedTags?.findIndex((c) => c._id === cat._id)
  //   if (x == -1) {
  //     // let x = [...selectedTags]
  //     // x.push({id: cat._id, Name: cat.Name})
  //     // setSelectedTags(x)
  //     selectedTags.push({ _id: cat._id, Name: cat.Name })
  //     setSelectedTags(selectedTags)
  //     setError(false)
  //   } else {
  //     selectedTags.splice(x, 1);
  //     setSelectedTags([...selectedTags]);
  //   }
  //   setTags([...tags])
  //   if (selectedTags.length === 0) {
  //     setError(true)
  //   }
  // }

  // const handleSelectAll = () => {
  //   // Check if all tags are already selected
  //   const allTagsSelected = selectedTags.length === tags.length;

  //   if (allTagsSelected) {
  //     // Deselect all tags
  //     setSelectedTags([]);
  //     setError(true); // Optional: Show error if no tags are selected
  //   } else {
  //     // Select all tags
  //     setSelectedTags([...tags]);
  //     setError(false);
  //   }
  // };

  const checkHandle = (cat) => {
    const tagIndex = selectedTags.findIndex((c) => c._id === cat._id);

    if (tagIndex === -1) {
      // Tag not found, add it
      setSelectedTags([...selectedTags, { _id: cat._id, Name: cat.Name }]);
      setError(false);
    } else {
      // Tag found, remove it
      const updatedTags = [...selectedTags];
      updatedTags.splice(tagIndex, 1);
      setSelectedTags(updatedTags);
    }

    setTags([...tags]);
    setError(selectedTags.length === 0);
  };

  const handleSelectAll = () => {
    const allTagsSelected = selectedTags.length === tags.length;

    // Toggle selection of all tags
    setSelectedTags(allTagsSelected ? [] : [...tags]);
    setError(!allTagsSelected);
  };




  const search = (e) => {
    setSearchValue(e.target.value)
  }

  const deleteTags = (x, ind) => {
    let a = [...selectedTags]
    a.splice(ind, 1)
    setSelectedTags(a)
    if (selectedTags.length === 1) {
      setError(true)
    }
  }

  // useEffect(()=>{
  //   let x= []
  //   for(let i=0;i<tags.length;i++){
  //     if(tags[i].checked){
  //       x.push(tags[i])
  //     }
  //   }
  //   setSelectedTags(x)
  // },[tags])






  useEffect(() => {
    httpService.getData(
      '/tag-master?search=' + searchValue,
      (res) => {
        console.log(res.data.data.data)
        setTags(res.data.data.data)
      },
      (err) => {
        message.error('Not able to fetch.')
      }
    )
  }, [searchValue])

  const submitForm = (e) => {
    e.preventDefault()
    setLoading(true)
    if (selectedTags.length === 0) {
      setLoading(false)
      setError(true)
    }
    else if (phrase.length === 0) {
      setLoading(false)
      setPhraseErr(true)
    }
    else {
      setError(false)
      httpService.patchData(
        '/website/update/?step=4',
        {
          id: history.location.state.id,
          Tags: selectedTags,
          phrases: phrase,
          publishDate: formatDate(date),
          publishTime: time,
        },
        (res) => {
          console.log(res)
          // setLoading(false)

          // history.push({
          //   pathname: '/addWebsite/associated-pages',
          //   state: {
          //     ...history.location.state,
          //     selectedTags,
          //   },
          // })

          httpService.postData(
            '/website/save/' + history.location.state.id,
            { data: {} },
            (res) => {
              message.success('Published!')
              setLoading(false)

              history.push({
                pathname: '/addWebsite/complete',
                state: {
                  ...history.location.state,
                },
              })
            },
            (err) => {
              setLoading(false)
              message.error(err.message)
            }
          )

          // message.success('Published!')
          // setLoading(false)

          // history.push({
          //   pathname: '/addWebsite/complete',
          //   state: {
          //     ...history.location.state,
          //   },
          // })
        },
        (err) => {
          setLoading(false)

          console.log(err)
        }
      )
    }
  }

  const check = (cat) => {
    let x = false
    selectedTags?.forEach((c) => {
      if (c.id === cat._id) {
        x = true
      }
    })
    return x
  }

  const [nameError, setNameError] = useState(false)
  // const validateName = (name: any) => {
  //   httpService.getData(
  //     '/' + history.location.state?.type.toLowerCase() + '-master/',
  //     (res: any) => {
  //       if (history.location.state?.type == 'Agency') {
  //         htmlFor (var i = 0; i < res.data.data?.agencies.length; i++) {
  //           if (res.data.data?.agencies[i].companyDetails.websiteURL == name) {
  //             setNameError(true)
  //             break
  //           } else {
  //             setNameError(false)
  //           }
  //         }
  //       } else {
  //         htmlFor (var i = 0; i < res.data.data?.brands.length; i++) {
  //           if (res.data.data?.brands[i].companyDetails.websiteURL == name) {
  //             setNameError(true)
  //             break
  //           } else {
  //             setNameError(false)
  //           }
  //         }
  //       }
  //     },
  //     (err: any) => {}
  //   )
  // }
  useEffect(() => {
    // setSelectedTags(history.location.state.website.Tags)
    setSelectedTags(history.location.state?.edit ? history.location.state?.website?.Tags : [])
    setPhrase(history.location.state?.edit ? history.location.state?.website?.phrases : [])
    setSuggestedPhrases(history.location.state?.selectedCategories);
  }, [])



  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPhraseInput(e.target.value);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    console.log("key", e.key)
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addPhrase();
    }
  };

  const addPhrase = () => {
    if (phraseInput.trim() !== '') {
      const updatedPhrases = [...phrase, phraseInput.trim().replace(/,$/, '')];
      setPhrase(updatedPhrases);
      setPhraseInput('');
    }
  };

  const handleRemovePhrase = (phraseIndex: number) => {
    setPhrase((prevPhrases) => prevPhrases.filter((_, index) => index !== phraseIndex));
  };

  const handleSuggestionClick = (suggestedPhrase: string) => {
    const lowerCaseSuggestedPhrase = suggestedPhrase.toLowerCase();
    const lowerCasePhrases = phrase.map(item => item.toLowerCase());
    if (lowerCasePhrases.includes(lowerCaseSuggestedPhrase)) {
      setErrorMessage('Phrase already exists');
    } else {
      // If not, add the suggestedPhrase to the array and clear the error message
      const updatedPhrases = [...phrase, suggestedPhrase];
      setPhrase(updatedPhrases);
      setErrorMessage('');
    }
  };

  const handleToggleSelectAllSuggestions = () => {
    const allSuggestedPhrases = suggestedPhrases.flatMap((item) => item.AssociatedPhrases);

    if (selectAllMode) {
      setPhrase(allSuggestedPhrases);
    } else {
      setPhrase([]);
    }
    setSelectAllMode(!selectAllMode);
  };


  console.log('suggestedPhrases', suggestedPhrases)


  return (
    <div className='CompanyDetailsOuter '>
      <AddWebsiteLeftBreadcrum currentStep='4' />
      <div
        className=''
        id='kt_login_signup_form'
        style={{ marginBottom: '100px' }}
      >
        <div className="CompanyDetails">


          <h2 className=''>Website Tags</h2>
          {error && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span className='text-danger' role='alert'>
                  Select atleast 1 tag.
                </span>
              </div>
            </div>
          )}
          <div className='row pt-4 pe-5 '>
            <div className='col d-flex flex-row  justify-content-start align-items-center flex-wrap'>
              {selectedTags &&
                selectedTags?.map((x, ind) => {
                  return (
                    <div className='d-flex align-items-center justify-content-around border px-3 py-2 m-2 rounded-pill'>
                      {x.Name}
                      <img
                        style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                        onClick={() => checkHandle(x)}
                        src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                        alt='cross'
                      />
                    </div>
                  )
                })}
            </div>
          </div>
          <div className='row pt-4 pe-5 '>
            <div className='col'>
              <Input
                type='text'
                placeholder='Search Tags.'
                className='form-control-solid rounded-6 border shadow-none pe-6 bg-white-100 mb-5'
                onChange={search}
                value={searchValue}
                prefix={
                  <>
                    <img src={toAbsoluteUrl('/media/icons/Custom/Search.svg')} alt='link' />
                  </>
                }
              />
              {/* <div className="input-group mb-5">
              <span className="input-group-text" style={{border:"none", paddingRight:"5px"}} id="basic-addon1">
                  <span className="svg-icon svg-icon-3x">
                      <img src={toAbsoluteUrl('/media/icons/Custom/Search.svg')} alt="search" />
                  </span>
              </span>
              <input type="text" className="form-control form-control-solid rounded-4 bg-white-100" style={{paddingLeft:"2px"}} onChange={search} value={searchValue} placeholder="Search tags"/>
          </div> */}
            </div>
          </div>
          <div className='d-flex align-items-center jEnd  px-3 py-2 m-2 '>
            <div className='custom-btn' onClick={handleSelectAll}>{selectedTags.length === tags.length ? 'Cancel All' : 'Select All'}</div>
          </div>

          <div className='row pe-5 pb-5 '>
            <div className='col scrollContainer'>
              {tags.map((cat, ind) => {
                return (
                  <div className='form-check form-check-custom form-check-solid form-check-sm m-4'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value={cat.Name}
                      id={cat.Name}
                      checked={selectedTags?.findIndex((c) => c._id === cat._id) > -1}
                      onClick={() => checkHandle(cat)}
                    />
                    <label className='form-check-label' htmlFor={cat.Name}>
                      {cat.Name}
                    </label>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="CompanyDetails">
          <h2 className=''>Website Phrases</h2>
          <div className="row">
            <div className="col">

              <p className='required'>Add Phrases (comma separated values)</p>
              {phraseErr && <p className='text-danger'>Atleast one phrase is required</p>}



              <div className='website-phrases-field'>
                {phrase.map((phrase, index) => (
                  <div className='d-flex align-items-center justify-content-around border px-3 py-2 m-2 rounded-pill'>
                    {phrase}
                    <img
                      style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                      onClick={() => handleRemovePhrase(index)}
                      src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                      alt='cross'
                    />
                  </div>
                ))}

                <input
                  type='text'
                  onChange={handleInputChange}
                  onKeyUp={handleKeyDown}
                  value={phraseInput}
                />
              </div>


            </div>
          </div>

          <div className="suggest-phrases-box">
            <div className="suggest-header-box">
              <p style={{ marginTop: "2rem", padding: 0 }}>Suggested Phrases from Category Master</p>
              <div className='custom-btn' onClick={handleToggleSelectAllSuggestions}>
                {selectAllMode ? 'Select All Phrases' : 'Cancel All Phrases'}
              </div>
            </div>
            <div className="suggest-phrases">
              {suggestedPhrases?.map((item, index) => (
                <div key={index} className='phrases-box'>
                  {item?.AssociatedPhrases?.map((item: any, index: any) => (
                    <div className='phrases' onClick={() => handleSuggestionClick(item)} key={index}>{item}</div>
                  ))}
                </div>
              ))}
            </div>
            {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
          </div>
        </div>


        {
          !history.location.state?.edit &&
          <div className="CompanyDetails d-flex align-items-center justify-content-between">
            <h2>Publish Schedule</h2>
            <div className="d-flex align-items-center">
              <div className="date-field">
                <input
                  type="date"
                  className='form-control bg-gray-200'
                  value={date}
                  onChange={handleDateChange}
                />
              </div>
              <div className="time-field ms-8">
                <input
                  type="time"
                  className='form-control bg-gray-200'
                  value={time}
                  onChange={handleTimeChange}
                  placeholder='Select Time'
                />
              </div>
            </div>
          </div>
        }


        <div className='d-flex pt-4 pe-5'>
          <button
            id='kt_sign_up_submit'
            className='btn btn-primary ms-5 CompanyDetailButton'
            onClick={submitForm}
            disabled={loading}
          // disabled={
          //   formik.isSubmitting ||
          //   !formik.isValid ||
          //   nameError ||
          //   !checkGST(formik.values.gstNumber)
          // }
          >
            {!loading && <span className='indicator-label'>Next</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
            {/* <span className='indicator-label'>Next</span> */}
          </button>
          <Link
            to={{
              pathname: '/addWebsite/categories',
              state: history.location.state,
            }}
          >
            <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
              Back
            </button>
          </Link>
        </div>
      </div>
    </div>
  )
}
